import React, {useEffect, useRef, useState} from 'react';

import WowzaWebRTCPlay from "./lib/WowzaWebRTCPlay";
import {Dispatch} from "redux";
import {withStyles} from "@mui/styles";
import styles from "../StreamTargetLive4tvApi/Live4tvApi-jss";
import {connect} from "react-redux";
import {StreamTargetList} from "../StreamTarget/streamTargetDTO";
import {Profile} from "../User/userDTO";

type Properties = {
    classes: any,
    liveEvent: any;
    streamTargets: StreamTargetList,
    profile: Profile,
}

const Player = (props: Properties) => {
    const signalingUrl = "wss://5fa0b37d2a2bd.streamlock.net/webrtc-session.json";
    const wsRef = useRef<WowzaWebRTCPlay | null>(null);
    const { liveEvent, streamTargets, profile } = props;
    console.log({liveEvent, streamTargets, profile});
    const streamName = liveEvent.event_transmission_accesses[0]?.reference;
    useEffect(() => {
        play();

        return () => {
            // Cleanup on unmount
            if (wsRef.current) {
                wsRef.current.stop();
                wsRef.current = null;
            }
        };
    }, [streamName]);

    const play = () => {
        // Clean up previous connection if exists
        if (wsRef.current) {
            wsRef.current.stop();
            wsRef.current = null;
        }

        wsRef.current = new WowzaWebRTCPlay();
        wsRef.current.on({
            onError: (error: any) => {
                console.log("Player.tsx Error: ", error);
            },
            onStateChanged: (state: any) => {
                console.log("Player.tsx State: ", state);
                if (state.connectionState === 'connected') {
                    connected();
                } else if (state.connectionState === 'failed' || state.connectionState === 'disconnected') {
                    console.log("Player.tsx Connection lost - stream stopped");
                    // The AutoStreamPreview component will detect this and switch back
                }
            }
        });
        wsRef.current.set({
            videoElementPlay:document.getElementById('player-video'),
        });

        const settings = {
            applicationName:"restream",
            sdpURL: signalingUrl,
            streamName: streamName
        }
        wsRef.current.set(settings).then(() => {
            wsRef.current?.play();
        });
    }

    const connected = () => {
        console.log("Player.tsx Connected");
        let videoElement = document.getElementById('player-video') as HTMLVideoElement;
        if (!videoElement) return;

        // Try to play immediately when connected
        const tryPlay = () => {
            if (videoElement && (videoElement.srcObject || videoElement.src)) {
                const playPromise = videoElement.play();
                if (playPromise !== undefined) {
                    playPromise
                        .then(() => {
                            console.log("Player.tsx Video autoplay started successfully");
                        })
                        .catch((error: any) => {
                            console.log("Player.tsx Autoplay prevented by browser, user interaction required:", error);
                        });
                }
            }
        };

        // Try immediately
        tryPlay();

        // Also try after a short delay in case stream isn't assigned yet
        setTimeout(tryPlay, 500);
        setTimeout(tryPlay, 1000);
        setTimeout(tryPlay, 2000);
    }

    // Listen for video events to autoplay when stream is ready
    useEffect(() => {
        const videoElement = document.getElementById('player-video') as HTMLVideoElement;
        if (!videoElement) return;

        const handleLoadedMetadata = () => {
            console.log("Player.tsx Video metadata loaded, attempting autoplay");
            const playPromise = videoElement.play();
            if (playPromise !== undefined) {
                playPromise
                    .then(() => {
                        console.log("Player.tsx Autoplay started after metadata loaded");
                    })
                    .catch((error: any) => {
                        console.log("Player.tsx Autoplay prevented:", error);
                    });
            }
        };

        const handleCanPlay = () => {
            console.log("Player.tsx Video can play, attempting autoplay");
            const playPromise = videoElement.play();
            if (playPromise !== undefined) {
                playPromise
                    .then(() => {
                        console.log("Player.tsx Autoplay started after canplay");
                    })
                    .catch((error: any) => {
                        console.log("Player.tsx Autoplay prevented:", error);
                    });
            }
        };

        const handleLoadedData = () => {
            console.log("Player.tsx Video data loaded, attempting autoplay");
            if (videoElement.paused) {
                const playPromise = videoElement.play();
                if (playPromise !== undefined) {
                    playPromise
                        .then(() => {
                            console.log("Player.tsx Autoplay started after data loaded");
                        })
                        .catch((error: any) => {
                            console.log("Player.tsx Autoplay prevented:", error);
                        });
                }
            }
        };

        videoElement.addEventListener('loadedmetadata', handleLoadedMetadata);
        videoElement.addEventListener('canplay', handleCanPlay);
        videoElement.addEventListener('loadeddata', handleLoadedData);

        return () => {
            videoElement.removeEventListener('loadedmetadata', handleLoadedMetadata);
            videoElement.removeEventListener('canplay', handleCanPlay);
            videoElement.removeEventListener('loadeddata', handleLoadedData);
        };
    }, []);

    return <>
         <video id={'player-video'} width={"500px"} controls autoPlay muted playsInline></video>
        </>
};

const mapStateToProps = function (state: any) {
    return {
        profile: state.user.profile,
        streamTargets: state.streamTargets,
        live4tvApiIntegration: state.live4tvApiIntegration,
    }
}

function mapDispatchToProps(dispatch: Dispatch) {
    return {};
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Player));
